export const opportunityFilter = Object.freeze({
  All: 0,
  CreatedFromRenewal: 1,
  CreatedFromNotRenewal: 2,
});
